import { ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { useCollapsed } from "@/components/Collapsible";

interface Props { id: string; title: ReactNode; summary?: ReactNode; actions?: ReactNode; forceOpen?: boolean; className?: string; testid?: string; children: ReactNode }

export function WoSection({ id, title, summary, actions, forceOpen, className = "", testid, children }: Props) {
  const { collapsed, toggle } = useCollapsed(`wo:${id}`);
  const open = forceOpen || !collapsed;
  return (
    <div className={className} data-testid={testid} data-collapsed={!open}>
      <div className="flex items-center justify-between gap-2">
        <button type="button" data-testid={`wo-section-toggle-${id}`} aria-expanded={open} title={open ? "Collapse" : "Expand"} onClick={toggle} className="flex min-w-0 items-center gap-1 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 transition-colors hover:text-gray-900">
          <ChevronDown size={14} className={`shrink-0 transition-transform ${open ? "" : "-rotate-90"}`} />
          <span className="flex items-center gap-1.5">{title}</span>
          {summary && <span className="ml-1 truncate font-normal normal-case tracking-normal text-gray-400">{summary}</span>}
        </button>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </div>
      {open && children}
    </div>
  );
}
